<template>
  <div class="image-container">
    <div class="background-image" :style="backgroundStyles"></div>
    <img :src="imageSrc" class="foreground-image" />
  </div>
</template>

<script>
export default {
  name: 'BImageWithBlurredBackground',
  props: {
    imageSrc: {
      type: String,
      default: undefined
    },
    blurAmount: {
      type: Number,
      default: 16
    },
    opacity: {
      type: Number,
      default: 0.8
    },
    maxHeight: {
      type: String,
      default: '616px'
    }
  },
  computed: {
    backgroundStyles() {
      return {
        'background-image': `url(${this.imageSrc})`,
        filter: `blur(${this.blurAmount}px)`,
        opacity: this.opacity
      };
    }
  }
};
</script>

<style scoped>
.image-container {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  max-height: v-bind(maxHeight);
  overflow: hidden;
}
.background-image {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.foreground-image {
  position: absolute;
  height: 100%;
  width: auto;
  max-width: 100%;
  left: 50%;
  transform: translateX(-50%);
  object-fit: contain;
}
</style>
